import React from 'react';
import T from 'components/T';
import { M } from '@dashboard-experience/mastodon';
import PropTypes from 'prop-types';
import MvrMatrixDocumentUpload from './MvrMatrixDocumentUpload';
import {
  DETAIL_LIST,
  JURISDICTIONS_MAPPING,
  getConsentFormUriForJurisdiction,
} from './mvrMatrixConstants';

function MvrMatrixDocumentUploadContainer({ field, formValue, onRemoveFile }) {
  const { translationPrefix } = DETAIL_LIST[field.name] || {};
  const jurisdiction = field.jurisdiction ?? '';

  if (!translationPrefix) return null;

  return (
    <M.Container>
      <M.GridRow>
        <M.GridCol lg={16}>
          <h2>
            <T
              value={`${translationPrefix}.displayTitle`}
              jurisdiction={JURISDICTIONS_MAPPING[jurisdiction] ?? jurisdiction}
            />
          </h2>
        </M.GridCol>
        <M.GridCol lg={16}>
          <hr />
        </M.GridCol>
      </M.GridRow>
      <M.GridRow>
        <M.GridCol lg={16}>
          <MvrMatrixDocumentUpload
            formValue={formValue}
            matrixField={field}
            consentFormUriOverride={getConsentFormUriForJurisdiction(
              field.jurisdiction,
            )}
            removeFile={onRemoveFile}
          />
        </M.GridCol>
      </M.GridRow>
    </M.Container>
  );
}

MvrMatrixDocumentUploadContainer.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    jurisdiction: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  formValue: PropTypes.object.isRequired,
  onRemoveFile: PropTypes.func.isRequired,
};

export default MvrMatrixDocumentUploadContainer;
